export enum SsoErrorType {
    FailToInitiateLogin = 1,
    UnableToProcessSsoLoginResponse = 2,
    UserNotAuthenticated = 3,
    UserNotFound = 4,
    InternalServerError = 5,
    FailToInitiateLogout = 6,
    FailToProcessLogout = 7,
    FailToRevokeTokens = 8,
    UnexpectedError = 9,
    UserIsNotEnabled = 10,
}

export const ReadableSsoError: { [code in SsoErrorType]: string } = {
    [SsoErrorType.FailToInitiateLogin]: $localize`Unable to initiate login with SSO`,
    [SsoErrorType.UnableToProcessSsoLoginResponse]: $localize`Unable to process SSO response`,
    [SsoErrorType.UserNotAuthenticated]: $localize`You are not authenticated`,
    [SsoErrorType.UserNotFound]: $localize`User not found`,
    [SsoErrorType.InternalServerError]: $localize`Internal Server Error`,
    [SsoErrorType.FailToInitiateLogout]: $localize`Unable to initiate logout with SSO`,
    [SsoErrorType.FailToProcessLogout]: $localize`Unable to logout with SSO`,
    [SsoErrorType.FailToRevokeTokens]: $localize`Unable to logout with SSO`,
    [SsoErrorType.UnexpectedError]: $localize`Something went wrong, please try again later`,
    [SsoErrorType.UserIsNotEnabled]: $localize`User has been disabled`,
};
